<script>
  import LinkItem from './Item.svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let links;
  let showingmore;

  let linkItems = links.items.filter((item) => item.id <= 4);
  let linkItemsMore = links.items.filter((item) => item.id > 4);

  let grow = false;
</script>

<section class="links container container--large">
  <h2
    class="h3 links__title"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    {links.title}
  </h2>
  <p
    class="links__desc"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    {links.desc}
  </p>
  <div
    class="links__items-block flexbox-full"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    {#each linkItems as item (item.id)}
      <div class="links__item-and-line col col-25 col-m-50 col-s-full">
        <LinkItem {item} />
        {#if item.id !== 4}
          <div
            class="line-vertical"
            class:grow
            use:viewport
            on:enterViewport={() => (grow = true)}
          />
        {/if}
        {#if item.id !== 1}
          <div
            class="line-horizontal"
            class:grow
            use:viewport
            on:enterViewport={() => (grow = true)}
          />
        {/if}
      </div>
    {/each}

    {#if showingmore && linkItemsMore.length}
      {#each linkItemsMore as item (item.id)}
        <div class="links__item-and-line col col-25 col-m-50 col-s-full">
          <LinkItem {item} />
          <div
            class="line-vertical"
            class:grow
            use:viewport
            on:enterViewport={() => (grow = true)}
          />
        </div>
      {/each}
    {/if}
  </div>

  {#if linkItemsMore.length}
    <div
      class="links__more-wrap"
      class:grow
      use:viewport
      on:enterViewport={() => (grow = true)}
    >
      <button
        class="links__more-btn btn btn-icon"
        class:showingmore
        on:click={() => {
          showingmore = !showingmore;
        }}
      >
        <i class="isax isax-arrow-down-1 links__more-btn-icon" />
        {#if showingmore}
          Show less
        {:else}
          Show all services
        {/if}
      </button>
    </div>
  {/if}
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes grow {
    0% {
      height: 0%;
      top: 50%;
    }

    90% {
      height: 110%;
      top: -5%;
    }

    100% {
      height: 100%;
      top: 0%;
    }
  }
  .links {
    text-align: center;

    &__title {
      max-width: 60rem;
      margin: 1rem auto 0;
      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
    }

    &__desc {
      margin: 1.8rem auto 0;
      max-width: 40rem;
      color: var(--royal-light);
      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
    }

    &__items-block {
      display: flex;
      margin-top: 5rem;
      flex-wrap: nowrap;
      justify-content: center;
      row-gap: 5rem;
      flex-wrap: wrap;

      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }

      @include resp-max('l') {
        flex-wrap: wrap;
      }

      @include resp-max('s') {
        row-gap: 0;
      }
    }

    &__item-and-line {
      position: relative;
      &:last-child > .line-vertical {
        display: none;
      }

      .line-vertical {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;

        &.grow {
          animation: grow ease-in-out 1s;
        }

        @include resp-max('m') {
          display: none;
        }
      }

      .line-horizontal {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;

        &.grow {
          animation: grow ease-in-out 1s;
        }

        @include resp-min('s') {
          display: none;
        }
      }
    }

    &__more-btn {
      font-size: 1.3rem;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      padding: 1rem 2rem;
      border: 1px solid $light-border;
      border-radius: 30px;
      gap: 0.8rem;
      margin-top: 6rem;

      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }

      &-icon {
        font-weight: 900;
        transition: transform 0.2s;
      }

      &.showingmore {
        .links__more-btn-icon {
          transform: rotateX(180deg);
        }
      }
    }
  }
</style>
